"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PRESENCE_ACTION;
(function (PRESENCE_ACTION) {
    PRESENCE_ACTION[PRESENCE_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    PRESENCE_ACTION[PRESENCE_ACTION["ERROR"] = 1] = "ERROR";
    PRESENCE_ACTION[PRESENCE_ACTION["QUERY_ALL"] = 2] = "QUERY_ALL";
    PRESENCE_ACTION[PRESENCE_ACTION["QUERY_ALL_RESPONSE"] = 3] = "QUERY_ALL_RESPONSE";
    PRESENCE_ACTION[PRESENCE_ACTION["QUERY"] = 4] = "QUERY";
    PRESENCE_ACTION[PRESENCE_ACTION["QUERY_RESPONSE"] = 5] = "QUERY_RESPONSE";
    PRESENCE_ACTION[PRESENCE_ACTION["PRESENCE_JOIN"] = 6] = "PRESENCE_JOIN";
    PRESENCE_ACTION[PRESENCE_ACTION["PRESENCE_JOIN_ALL"] = 7] = "PRESENCE_JOIN_ALL";
    PRESENCE_ACTION[PRESENCE_ACTION["PRESENCE_LEAVE"] = 8] = "PRESENCE_LEAVE";
    PRESENCE_ACTION[PRESENCE_ACTION["PRESENCE_LEAVE_ALL"] = 9] = "PRESENCE_LEAVE_ALL";
    PRESENCE_ACTION[PRESENCE_ACTION["SUBSCRIBE"] = 10] = "SUBSCRIBE";
    PRESENCE_ACTION[PRESENCE_ACTION["UNSUBSCRIBE"] = 11] = "UNSUBSCRIBE";
    PRESENCE_ACTION[PRESENCE_ACTION["SUBSCRIBE_ALL"] = 12] = "SUBSCRIBE_ALL";
    PRESENCE_ACTION[PRESENCE_ACTION["UNSUBSCRIBE_ALL"] = 13] = "UNSUBSCRIBE_ALL";
    PRESENCE_ACTION[PRESENCE_ACTION["INVALID_PRESENCE_USERS"] = 100] = "INVALID_PRESENCE_USERS";
    PRESENCE_ACTION[PRESENCE_ACTION["MESSAGE_PERMISSION_ERROR"] = 101] = "MESSAGE_PERMISSION_ERROR";
    PRESENCE_ACTION[PRESENCE_ACTION["MESSAGE_DENIED"] = 102] = "MESSAGE_DENIED";
    PRESENCE_ACTION[PRESENCE_ACTION["MULTIPLE_SUBSCRIPTIONS"] = 103] = "MULTIPLE_SUBSCRIPTIONS";
    PRESENCE_ACTION[PRESENCE_ACTION["NOT_SUBSCRIBED"] = 104] = "NOT_SUBSCRIBED";
})(PRESENCE_ACTION = exports.PRESENCE_ACTION || (exports.PRESENCE_ACTION = {}));
//# sourceMappingURL=presence.js.map